


var collapsibles = document.querySelectorAll(".custom_mw_collapsible");
  
for (var i = 0; i < collapsibles.length; i++) {
  collapsibles[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

// [perf] Arrow-visibility binding, first->last reorder, and slick init
// are now done per-tile inside initTile(), lazily via IntersectionObserver
// (see the lazyInitCarousels block below). Behavior after init is unchanged.

// when hover click to the slick button than hide teh overlay image for each
document.addEventListener('click', (e) => {
  // Check if clicked element or its parent is .slick-next
  const slickNext = e.target.closest('.custom_autoplay .slick-next');
  if (slickNext) {
    // console.log("clicked to the slider button");

    // Find the closest slider wrapper for this button
    const sliderWrapper = slickNext.closest('.custom_autoplay');
    if (sliderWrapper) {
      // Hide only the overlay inside this slider
      const overlay = sliderWrapper.parentElement.querySelector('.hover-image-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        // console.log('.hover-image-overlay hidden for this slider');
      }
    }
  }
});
// end


// [perf] Lazy per-tile Slick init.
// Was: one $('.custom_autoplay').slick(...) over every tile at load (~2.6s TBT
// on a full collection). Now each tile initializes only when it nears the
// viewport (IntersectionObserver) or is hovered on desktop. Un-initialized
// tiles already render their first image via the
// .custom_autoplay:not(.slick-initialized) CSS, so there is no layout flash.
var slickConfig = {
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 6000,
  arrows: true,
  dots: true,
  speed: 0,
    fade: true,
  infinite: true,
  touchThreshold: 10, // [swipe] minSwipe = tileWidth/threshold; 5->10 cuts it ~37px->~19px so an arced left-thumb swipe latches before Slick's 4px vertical axis-lock trips
  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><img src="https://cdn.shopify.com/s/files/1/0732/9117/files/iconlt.png?v=1752125881"></button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next"><img src="https://cdn.shopify.com/s/files/1/0732/9117/files/iconriht.png?v=1752125863"></button>',
  responsive: [
    { breakpoint: 1024, settings: {
        slidesToShow: 1, slidesToScroll: 1, autoplay: false, autoplaySpeed: 6000,
        arrows: true, dots: true, speed: 150, cssEase: 'ease-in-out', fade: true, infinite: true,
    } },
    { breakpoint: 768, settings: {
        slidesToShow: 1, slidesToScroll: 1, autoplay: false, autoplaySpeed: 6000,
        arrows: true, dots: true, speed: 150, cssEase: 'ease-in-out', fade: false, infinite: true,
    } },
  ]
};

function initTile(el) {
  var $el = $(el);
  if ($el.hasClass('slick-initialized')) return;

  // Desktop-only: move first slide to last (was a global pass on load).
  if (window.innerWidth > 1024 && $el.hasClass('cus-arrangements')) {
    var wrappers = el.querySelectorAll('.cus-arrange');
    if (wrappers.length > 1) {
      el.appendChild(wrappers[0]);
    }
  }

  // Bind arrow-visibility handlers before .slick() so 'init' is caught.
  $el.on('init', function (event, slick) {
    updateArrowVisibility(slick, 0);
  }).on('afterChange', function (event, slick, currentSlide) {
    updateArrowVisibility(slick, currentSlide);
  });

  $el.slick(slickConfig);
}

(function lazyInitCarousels() {
  var tiles = document.querySelectorAll('.custom_autoplay');
  if (!tiles.length) return;

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          initTile(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '600px 0px' });

    tiles.forEach(function (tile) {
      io.observe(tile);
      // Desktop accelerator: init instantly on hover if not yet done.
      tile.addEventListener('mouseenter', function () {
        initTile(tile);
        io.unobserve(tile);
      }, { once: true });
    });
  } else {
    // No IntersectionObserver support: fall back to old behavior.
    tiles.forEach(initTile);
  }
})();

// Show only next arrow on first slide, otherwise show both
function updateArrowVisibility(slick, currentSlide) {
  const $slider = $(slick.$slider);
  const $prevArrow = $slider.find('.slick-prev');
  const $nextArrow = $slider.find('.slick-next');

  if (slick.slideCount <= 1) {
    // Only one slide — hide both arrows
    $prevArrow.hide();
    $nextArrow.hide();
  } else if (currentSlide === 0) {
    // First slide — show only next
    $prevArrow.show();
    $nextArrow.show();
  } else {
    // All other slides (including last) — show both
    $prevArrow.show();
    $nextArrow.show();
  }
}

// To stop redirection to product page and udes the slider for the product card
$(document).on('click', 'a:has(.custom_autoplay)', function (e) {
  // If the click is on a slick arrow inside the anchor, prevent redirect
  if ($(e.target).closest('.slick-arrow').length > 0) {
    e.preventDefault();     // Prevent anchor navigation
    e.stopPropagation();    // Stop bubbling
    // console.log('✔ Slick arrow clicked – redirect prevented, slider works');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Add to cart on size click using Fetch API
  // document.querySelectorAll(".size-btn").forEach(button => {
  //   button.addEventListener("click", function (e) {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     // Check if disabled
  //     if (this.classList.contains("disabled")) {
  //       console.warn("⚠️ Clicked unavailable size – no action taken.");
  //       return;
  //     }

  //     const variantId = this.getAttribute("data-variant-id");
  //     // console.log("🛈 Clicked size button, variant ID:", variantId);

  //     if (!variantId) {
  //       // console.warn("✘ No variant ID found – skipping add to cart");
  //       return;
  //     }

  //     fetch("/cart/add.js", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "Accept": "application/json"
  //       },
  //       body: JSON.stringify({
  //         id: variantId,
  //         quantity: 1
  //       })
  //     })
  //     .then(response => {
  //       if (!response.ok) throw new Error("Network error");
  //       return response.json();
  //     })
  //     .then(data => {
  //       console.log("✔ Successfully added to cart:", data);
  //     })
      
  //     .catch(error => {
  //       // console.error("✘ Failed to add to cart:", error);
  //       // alert("⚠️ Failed to add to cart.");
  //     });
      
  //   });
  // });

  document.querySelectorAll(".size-btn").forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Check if disabled
      if (this.classList.contains("disabled")) {
        console.warn("⚠️ Clicked unavailable size – no action taken.");
        return;
      }

      // // 🔒 Disable all buttons for 4 seconds
      // const allButtons = document.querySelectorAll(".size-btn");
      // allButtons.forEach(btn => btn.classList.add("disabled"));

      // setTimeout(() => {
      //   allButtons.forEach(btn => btn.classList.remove("disabled"));
      // }, 3000); // 4 seconds

      const variantId = this.getAttribute("data-variant-id");
      if (!variantId) {
        console.warn("✘ No variant ID found – skipping add to cart");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) throw new Error("Network error");
        return response.json();
      })
      .then(data => {
        console.log("✔ Successfully added to cart:", data);
      })
      .catch(error => {
        console.error("✘ Failed to add to cart:", error);
      });
    });
  });


  // Prevent redirect when clicking on size buttons inside <a> tags
  document.querySelectorAll("a:has(.size-btn)").forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      if (e.target.closest(".size-btn")) {
        e.preventDefault();
        e.stopPropagation();
        // console.log("✔ Size button clicked – redirect prevented");
      }
    });
  });

  let selectArrow = document.getElementById("menu_mobile_view");
  let selectArrowIcon = document.querySelector(".category-icon_container");

  let isRotated = false;

  selectArrow.addEventListener("click", function () {
    if (isRotated) {
      selectArrowIcon.style.transform = "rotate(0deg)";
    } else {
      selectArrowIcon.style.transform = "rotate(90deg)";
    }

    isRotated = !isRotated;
  });

});



// Don't remove this 
// Slider prev-next functionality

// document.addEventListener("DOMContentLoaded", function () {
//   const sliders = document.querySelectorAll(".cus-prd_slider");

//   sliders.forEach(slider => {
//     let prevClickedOnce = false; 
//     let nextClickedOnce = false;
//     let nextClicked = false;
//     let prevClicked = false;
//     const $slider = $(slider);
//     const hoverOverlay = slider.parentElement.querySelector(".hover-image-overlay");

//     const nextBtn = slider.parentElement.querySelector(".slick-next img");
//     const prevBtn = slider.parentElement.querySelector(".slick-prev img");
    
//     // Handle Next Button
//     if (nextBtn) {
//       nextBtn.addEventListener("click", function (e) {
//         e.preventDefault();
//         nextClicked = true;

//         if (hoverOverlay) {
//           hoverOverlay.classList.add("hide-hover-overlay");
//         }

//         const slickObj = $slider.slick('getSlick');
//         let currentSlide = slickObj.currentSlide;

//         if (!nextClickedOnce && !prevClicked) {
//           nextBtn.disabled = true;

//           $slider.slick('slickGoTo', currentSlide + 1, true); 
//           // console.log("Current next slide : ", currentSlide);
          
//           setTimeout(() => {
//             $slider.slick('slickNext'); 

//             // Re-enable the next button after the movement
//             nextBtn.disabled = false;

//           }, 200);

//           nextClickedOnce = true;
//         } else {
//           // Normal click
//           $slider.slick('slickNext');
//         }
//       });
//     }

//     // Handle Prev Button
//     if (prevBtn) {
//       prevBtn.addEventListener("click", function (e) {
//         e.preventDefault();
//         prevClicked = true;

//         if (hoverOverlay) {
//           hoverOverlay.classList.add("hide-hover-overlay");
//         }

//         const slickObj = $slider.slick('getSlick');
//         const currentSlide = slickObj.currentSlide;

//         if (!prevClickedOnce && !nextClicked) {
//           // First click and next hasn't been clicked yet
//           prevBtn.disabled = true;

//           $slider.slick('slickGoTo', currentSlide + 1, true);
//           // console.log("Current slide : ", currentSlide);

//           setTimeout(() => {
//             // console.log("Now moving to the previous slide.");
//             $slider.slick('slickPrev');

//             // Re-enable the prev button after the movement
//             prevBtn.disabled = false;
//           }, 200);

//           prevClickedOnce = true;
//         } else {
//           // Normal click
//           // console.log("PREV clicked. Going to previous slide.");
//           $slider.slick('slickPrev');
//         }
//       });
//     }

//   });
// });

